"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.RelatedDisclosureSchema = exports.DisclosureSchema = exports.scoringSchema = exports.SubmittedFacultyMemberSchema = exports.DisclosureStageSchema = void 0;
const z = __importStar(require("zod"));
const contributor_1 = require("./contributor");
const dean_1 = require("./dean");
const drd_1 = require("./drd");
const hod_1 = require("./hod");
const disclosure_enums_1 = require("../enums/disclosure-enums");
exports.DisclosureStageSchema = z.nativeEnum(disclosure_enums_1.DisclosureStage);
exports.SubmittedFacultyMemberSchema = z.object({
    Name: z.string().min(1),
    // Trim: JotForm emails arrive with stray whitespace, which fails .email() downstream
    Email: z.string().trim().min(1),
    Faculty: z.string(),
});
exports.scoringSchema = z.object({
    scoreMarket: z.number(),
    scoreViability: z.number(),
    scoreFeasibility: z.number(),
    scoreContext: z.number(),
    scoreIp: z.number(),
    scoreResource: z.number(),
    scoreFunding: z.number(),
    scoreExpectations: z.number(),
    scoreTotal: z.number(),
});
exports.DisclosureSchema = z.object({
    id: z.string(),
    name: z.string(),
    shortDescription: z.string(),
    stage: exports.DisclosureStageSchema,
    primaryEmail: z.string(),
    primaryFirstName: z
        .string()
        .min(1, { message: 'First name must have at least one character' }),
    primaryLastName: z
        .string()
        .min(1, { message: 'Last name must have at least one character' }),
    faculty: z.string(),
    createdAt: z.date(),
    updatedAt: z.date(),
    submissionId: z.string(),
    disclosureWebhookDataId: z.string(),
    score: exports.scoringSchema.nullish(),
    softDelete: z.boolean().default(false),
    disclosureNumber: z.string().nullish(),
    userId: z.string().nullish(),
});
/**
 * RelatedDisclosureSchema contains all relations on your model in addition to the scalars
 *
 * NOTE: Lazy required in case of potential circular dependencies within schema
 */
exports.RelatedDisclosureSchema = z.lazy(() => exports.DisclosureSchema.extend({
    contributors: contributor_1.ContributorSchema.array(),
    hODs: z.array(hod_1.HODSchema),
    deans: z.array(dean_1.DeanSchema),
    drd: drd_1.DRDSchema,
    ttoDirector: z.object({
        id: z.string(),
        name: z.string().min(1),
        email: z.string().trim().email(),
        signoffStatus: contributor_1.SignoffStatusSchema,
        disclosureId: z.string(),
        reason: z.string().nullish(),
    }),
}));
